module.exports = __webpack_public_path__ + "img/Feature.ccc0b52b.jpg";